import React, { Component } from 'react'
import Grid from '@material-ui/core/Grid'
import Paper from '@material-ui/core/Paper'
import { Collapse } from '@material-ui/core'
import cn from 'classnames'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import SvgIcon from '@material-ui/core/SvgIcon'
import PropTypes from 'prop-types'
import moment from 'moment'
import { CHART_TYPE_FORECAST, listViewList } from 'helpers/environmentMonitor'
import ListViewHistorical from 'components/Apps/EnvironmentMonitor/ListViewHistorical'
import { resetForecastData } from 'reducers/environmentMonitor/reducer'
import messages from './translate'
import { mathRound } from '../../../helpers/math'

class ListView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      isDetailsOpen: false,
    }
  }

  componentWillUnmount() {
    this.props.resetForecastData()
  }

  onDetailsToggle = () => {
    this.setState(prevState => ({ isDetailsOpen: !prevState.isDetailsOpen }))
  }

  getDetailsList = () => {
    const {
      intl: { formatMessage },
      dataView,
    } = this.props

    return (
      <ul className="detail-list">
        {listViewList.map(item => {
          const value = dataView.get(item)

          return (
            <li key={item} className="list-item">
              <span className="name">{formatMessage(messages[item])}</span>
              <span className="value">
                {typeof value === 'number' ? mathRound(value) : '--'}
              </span>
            </li>
          )
        })}
      </ul>
    )
  }

  render() {
    const {
      intl: { formatMessage },
      icon,
      unit,
      chartType,
    } = this.props
    const { isDetailsOpen } = this.state
    const forecastDetails = `12H ${formatMessage(
      messages.forecast,
    )} ${formatMessage(messages.details)}`
    const lastDetails = `${formatMessage(messages.last)} 12H ${formatMessage(
      messages.details,
    )}`
    const date = this.props.listForecastData.get('time')
    const value = this.props.listForecastData.get('value')
    const isAfterDate = date.isAfter() ? messages.tomorrow : messages.yesterday
    const dayName = formatMessage(
      date.isSame(moment(), 'day') ? messages.today : isAfterDate,
    )

    return (
      <Grid item lg={4} md={4} sm={12} xs={12}>
        {chartType !== CHART_TYPE_FORECAST ? (
          <ListViewHistorical unit={unit} icon={icon} />
        ) : (
          <Paper className="sensor-list sensor-type">
            <div className="current-time">{`${dayName} - ${date.format(
              'HH',
            )}:00`}</div>
            <div className="current-type">
              <div className="type-data">
                {value} <span>{unit}</span>
              </div>
              <div className="type-icon">
                <SvgIcon component={icon}>icon</SvgIcon>
              </div>
            </div>
            <div
              className={cn('forecast-details', { 'is-open': isDetailsOpen })}
              onClick={this.onDetailsToggle}>
              {chartType === CHART_TYPE_FORECAST
                ? forecastDetails
                : lastDetails}
            </div>
            <Collapse in={isDetailsOpen}>{this.getDetailsList()}</Collapse>
          </Paper>
        )}
      </Grid>
    )
  }
}

ListView.defaultProps = {
  icon: () => {},
  unit: '',
}

ListView.propTypes = {
  icon: PropTypes.func,
  unit: PropTypes.string,
  dataView: PropTypes.object,
  chartType: PropTypes.string,
}

export default connect(
  state => ({
    listForecastData: state.getIn(['environmentMonitor', 'listForecastData']),
  }),
  {
    resetForecastData,
  },
)(injectIntl(ListView))
